import React from "react";

const TeamCard = ({ member }) => (
  <div className="col-md-6 col-lg-4">
    <div className="h_400x w-100 br_10 overflow-hidden position-relative">
      <div className="position-relative w-100 h-100">
        <img
          src={member.image}
          className="position-absolute w-100 h-100 object-fit-cover"
          alt={member.name}
          style={{ filter: "grayscale(100%)" }}
        />
        <div className="d-flex justify-content-end flex-column h-100 p-3 position-relative z-5">
          <div className="bg-white d-flex flex-column justify-content-end p-2 p-lg-3 position-relative br_10">
            <h5 className="card-title text-center">{member.name}</h5>
            <p className="card-subtitle text-center mb-1 mt-1 text_master2">
              {member.role}
            </p>
            <p className="card-text text-center text_light1">{member.bio}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default TeamCard;
